import React from "react";

import { Box, makeStyles } from "@material-ui/core";
import { Save as SaveIcon } from "react-feather";

import { useTealium } from "@hubcapp/context";
import Button from "@ds-developer/button";

import { FormPageActionsProps } from "./types";

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row-reverse",
      justifyContent: "flex-end",
    },

    "& > *": {
      "&:not(last-child)": {
        marginBottom: theme.spacing(2),

        [theme.breakpoints.up("sm")]: {
          marginBottom: 0,
          marginRight: theme.spacing(4),
        },
      },
    },
  },
}));

const FormPageActions: React.FC<FormPageActionsProps> = ({
  loading = false,
  submitDisabled = false,
  discardDisabled = false,
  onSaveClick = () => {},
  onDiscardClick = () => {},
}) => {
  const classes = useStyles();
  const { trackEvent } = useTealium();

  return (
    <Box className={classes.wrapper}>
      <Button
        type="submit"
        variant="contained"
        color="secondary"
        startIcon={<SaveIcon size={16} />}
        loading={loading}
        onClick={() => {
          trackEvent({
            eventCategory: "My Details",
            eventAction: "Button Click",
            eventLabel: "Save Changes",
          });
          onSaveClick();
        }}
        disabled={submitDisabled}
        data-test="submit-button"
      >
        Save changes
      </Button>

      <Button
        variant="outlined"
        type="button"
        disabled={discardDisabled}
        onClick={() => {
          onDiscardClick();
        }}
        data-test="discard-button"
      >
        Discard
      </Button>
    </Box>
  );
};

export default FormPageActions;
